import { useLocation } from 'react-router-dom'
import Authenticate from '../../components/authenticator/Authenticate'
import { ProgressBar } from '../../components/guided-onboarding/ProgressBar'
import { useState } from 'react'
import { ShieldCheckIcon } from '@heroicons/react/24/outline'

function AuthenticateStepPage() {
    const { state }: any = useLocation()

    const [isSigningUp, setIsSigningUp] = useState(!state?.signIn)

    return (
        <>
            {isSigningUp && (
                <div className="max-w-xl mx-auto">
                    <ProgressBar currentStep={1} totalSteps={3} />
                </div>
            )}
            <div className="bg-white rounded-2xl p-6 md:p-8 border border-border shadow-lg max-w-xl mx-auto animate-fade-in">
                <div className="mx-auto h-14 w-14 rounded-full bg-red-50 mb-4 flex items-center justify-center">
                    <ShieldCheckIcon className="w-8 h-8 text-red-500" />
                </div>
                <div className="mb-6 text-center">
                    <h1 className="text-2xl md:text-3xl mb-3">
                        {isSigningUp ? 'Create your account' : 'Sign in to your account'}
                    </h1>
                    <p className="text-base text-muted-foreground max-w-2xl mx-auto mb-4">
                        {isSigningUp
                            ? 'Create your secure Arwen account and connect your social media profiles'
                            : 'Sign in to your account to see your dashboard'}
                    </p>
                </div>
                <Authenticate
                    hideSignUp={false}
                    initialState={state?.signIn ? 'signIn' : 'signUp'}
                    showHeader={false}
                    onTabChange={(route) => setIsSigningUp(route === 'signUp')}
                />
            </div>
        </>
    )
}

export default AuthenticateStepPage
